import { SearchRounded } from '@mui/icons-material';
import {
    Card,
    CardActionArea,
    CardContent,
    Divider,
    Grid,
    OutlinedInput,
    Typography,
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import { daysOfWeek } from '../../store/local/contents';
import { rtGetListData } from '../../store/slices/listSlice';

export default function DevotionsScreen() {
    const [search, setSearch] = useState('');

    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { devotions, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('devotions', 'devotions'));
    }, [dispatch]);

    return (
        <Screen loading={busy['devotions']} title="Devotions">
            <Grid item xs={12}>
                <OutlinedInput
                    value={search}
                    startAdornment={<SearchRounded className="me-2" />}
                    fullWidth
                    placeholder="Type to search"
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                {devotions
                    ?.filter((devotion) =>
                        JSON.stringify(devotion)
                            ?.toLowerCase()
                            .includes(search?.toLowerCase())
                    )
                    .map((devotion) => (
                        <DevotionCard key={devotion?.id} devotion={devotion} />
                    ))}
            </Grid>
            <Divider />
            {!busy['devotions'] && devotions?.length < 1 && <ListEmpty />}
        </Screen>
    );
}

const DevotionCard = ({ devotion }) => {
    const { id, dated, title, type, writer } = devotion;
    const navigate = useNavigate();

    return (
        <Card variant="outlined" className="mb-2">
            <CardActionArea
                onClick={() => navigate(`/devotion/${id}`, { state: devotion })}
            >
                <CardContent>
                    <Grid container>
                        <Grid item xs={3}>
                            <Typography className="text-uppercase fw-bold">
                                {moment(dated).format('MMM')}
                            </Typography>
                            <Typography className="fw-bold">
                                {moment(dated).format('DD')}
                            </Typography>
                            <Typography className="text-uppercase fw-bold">
                                {daysOfWeek[
                                    moment(dated).isoWeekday() - 1
                                ]?.slice(0, 3)}
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography>Type: {type}</Typography>
                            <Typography className="text-uppercase ">
                                {title}
                            </Typography>
                            <Typography>{writer}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
